import Vue from 'vue'
import App from './App.vue'
import store from "./store"
import router from './router'
import NotifyPlugin from 'vue-easy-notify'
import 'vue-easy-notify/dist/vue-easy-notify.css'
import DiaMonD from "../public/scripts/diamond-api.min.js";
import { dateHelper, numHelpers, strHelpers, resizer, arrayHelpers } from "@/mixins"
import { clickOutside } from "@/directives"
import { Constants } from "../public/scripts/diamond-api.min.js";
import { objectHelpers } from './mixins'
import Toolbox from "@/toolbox";
import GlobalComponents from "./globalComponents";
import 'devextreme/dist/css/dx.light.css';

// window.usingLiveApi = true

Vue.config.productionTip = false

// START MIXIN DECLARATIONS //
Vue.mixin(dateHelper);
Vue.mixin(numHelpers);
Vue.mixin(strHelpers);
Vue.mixin(objectHelpers);
Vue.mixin(arrayHelpers);
Vue.mixin(resizer);
// END MIXIN DECLARATIONS //

Vue.use(GlobalComponents);

// START USING DECLARATIONS //
Vue.use(NotifyPlugin)
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faLock,
  faLockOpen,
  faChevronRight,
  faChevronLeft,
  faArrowUp,
  faFilter,
  faTrashAlt,
  faArrowsAltV,
  faListUl,
  faWindowClose,
  faPhone,
  faPhoneSlash,
  faHourglassHalf,
  faCog,
  faQuestion,
  faCaretSquareDown,
  faCheck,
  faSignOutAlt,
  faPauseCircle,
  faBan,
  faSearch,
  faWind,
  faKeyboard,
  faExchangeAlt,
  faClock,
  faHeadset,
  faAsterisk,
  faEyeSlash,
  faMicrophoneAltSlash
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(faAsterisk, faMicrophoneAltSlash, faEyeSlash, faHeadset, faClock, faExchangeAlt, faKeyboard, faWind, faSearch, faBan, faPauseCircle, faSignOutAlt, faLock, faLockOpen, faChevronRight, faChevronLeft, faArrowUp, faFilter, faTrashAlt, faArrowsAltV, faListUl, faWindowClose, faPhone, faPhoneSlash, faHourglassHalf, faCog, faQuestion, faCaretSquareDown, faCheck)

// END USING DECLARATIONS //

// ADD TOOLBOX TO GLOBAL
Vue.prototype.$toolbox = Toolbox
// END ADD TOOLBOX

// START PROTOTYPE DECLARATIONS //
let sessionSite = 0;
Vue.prototype.$connectToDiamond = (location, token, site, changeSite = false) => {
  if (!Vue.prototype.$diamond || changeSite) {
    if(site != null) sessionSite = site
    let diamond = new DiaMonD(location, token, sessionSite);

    Vue.prototype.$diamond = diamond;
    return diamond.start()
  } else {
    localStorage.token = token
    return Promise.resolve()
  }
}
Vue.prototype.$constants = Constants;
// END PROTOTYPE DECLARATIONS //

// START DIRECTIVE DECLARATIONS //
Vue.directive('click-outside', clickOutside);
// END DIRECTIVE DECLARATIONS //

import VueVirtualScroller from 'vue-virtual-scroller'
Vue.use(VueVirtualScroller)
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import VueMultiRef from 'vue-multi-ref'
Vue.use(VueMultiRef)

Vue.prototype.$eventHub = new Vue();

var vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

Vue.prototype.$toast = (type, str) => {
  vue.$notify({
    message: str,
    type: type,
    size: "sm",
    timeout: 1000,
    showClose: false,
  });
}